import { Container } from 'models/common';

export const canUseDOM = !!(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
);

export function getTarget(target: Container) {
    const els = findDOMElements(target);

    if (!els) {
        return els;
    }

    if (els instanceof HTMLElement) {
        return els;
    } else if (Array.isArray(els) || (canUseDOM && typeof els.length === 'number')) return els[0];

    throw new Error('Unknown error');
}

export function findDOMElements(target: Container) {
    if (typeof target === 'string') {
        if (!canUseDOM) return null;

        let selection = document.querySelectorAll(target);
        if (!selection.length) {
            selection = document.querySelectorAll(`#${target}`);
        }
        if (!selection.length) {
            return null;
        }
        return selection;
    }

    if (target && typeof target === 'object' && 'current' in target) {
        return target.current;
    }

    return target;
}

export function assertIsNode(e: EventTarget | null): asserts e is Node {
    if (!e || !('nodeType' in e)) {
        throw new Error(`Node expected`);
    }
}
